import solutionFile from "refractor/solution-file";
export default solutionFile;